import defaultDayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isBetween from "dayjs/plugin/isBetween";
import relativeTime from "dayjs/plugin/relativeTime";
import weekday from "dayjs/plugin/weekday";
import localizedFormat from "dayjs/plugin/localizedFormat";
import dayjsBusinessDays from "dayjs-business-days";
import weekOfYear from "dayjs/plugin/weekOfYear";
import "dayjs/locale/sq";

defaultDayjs.locale("sq");
defaultDayjs.extend(utc);
defaultDayjs.extend(timezone);
defaultDayjs.extend(customParseFormat);
defaultDayjs.extend(duration);
defaultDayjs.extend(relativeTime);
defaultDayjs.extend(isSameOrBefore);
defaultDayjs.extend(isBetween);
defaultDayjs.extend(isSameOrAfter);
defaultDayjs.extend(weekday);
defaultDayjs.extend(weekOfYear);
defaultDayjs.extend(localizedFormat);
defaultDayjs.extend(dayjsBusinessDays);

const guessedTimeZone = defaultDayjs.tz.guess();

function getLastSunday(year, month) {
  let lastDay = new Date(year, month + 1, 0);
  let dayOfWeek = lastDay.getDay();
  let lastSunday = new Date(lastDay);
  lastSunday.setDate(lastDay.getDate() - dayOfWeek);

  return lastSunday;
}

const getOffsetTz = (...args) => {
  const date = defaultDayjs(...args);
  const year = date.year();

  const dstStart = getLastSunday(year, 2); // march
  const dstEnd = getLastSunday(year, 9); // october

  const dstStartDate = defaultDayjs(dstStart);
  const dstEndDate = defaultDayjs(dstEnd);

  const isDST =
    date.isAfter(dstStartDate.subtract(1, "day")) &&
    date.isBefore(dstEndDate.add(1, "day"));

  // Albania timezone: GMT+1 (winter) / GMT+2 (summer)
  return isDST ? "Etc/GMT-2" : "Etc/GMT-1";
};

// defaultDayjs.tz.setDefault("America/New_York");
if (!guessedTimeZone.startsWith("Europe/Tirane")) {
  defaultDayjs.tz.setDefault("Europe/Tirane");
}

const dayjsTZ = (...args) => {
  return defaultDayjs(...args).tz(getOffsetTz(...args));
};

const timezonedUnix = (value) => {
  return defaultDayjs.unix(value).tz(getOffsetTz(value));
};

dayjsTZ.unix = timezonedUnix;

export default dayjsTZ;
